import React from "react";
import {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../../components/Utils";
import { pushItemsInSelectedFilters } from "../../../components/UtilsForCart";
import {Filter} from "../../Entity/Filter";
import {useSelector} from "react-redux";
import {RootState} from "../../../app/RootReducer";

interface ComponentProps {
  taxonItem: any,
  subTaxonItem: Filter,
  filtersSelected: {index: string, values: string[]}[],
  setFiltersSelected: React.Dispatch<React.SetStateAction<{index: string, values: string[]}[]>>,
  setGroupCode: React.Dispatch<React.SetStateAction<string>>,
  filtersSelectedParent: string
}
const RadioFilter = ({taxonItem, subTaxonItem, filtersSelected, setFiltersSelected,setGroupCode, filtersSelectedParent}: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const filters = useSelector((state:RootState) => state.filtersRdc.filters);
  const setRadioFilter = (item: Filter) => {
    const index = item.groupCode ?? "";
    if (!index) return;

    const next = [
      ...filtersSelected.filter(f => f.index !== index),
      { index, values: [item.code] }
    ];

    setFiltersSelected(next);
    setGroupCode(index);
  };

  return (
    <label className="form-check mb-2" key={subTaxonItem.code+subTaxonItem.label}>
      <input className="form-check-input" type="radio" name={taxonItem[0]} onChange={() => setRadioFilter(subTaxonItem)}/>
      <span className="form-check-label"> { subTaxonItem.label } </span>
    </label>
  )
}
export default RadioFilter;


